import axios from 'axios'
import Apimaster from "../service/Master";

export default {
  checkCompanyByValue (Val, Callback) {
    let companyAPI = axios.defaults.baseURL
    let MSG = ''

    Apimaster.MasterMain({
      Module: "DDLLoginCompany",
    }, (res) => {
      if (res === null || res === "") {
        MSG = "Error not found."
      }
      
      if (res.data.Status === true) {
        const getCompany = res.data.body.filter((item)=> {
          return item.value == Val
        })

        if (getCompany.length !== 0) { // change api path by company
          companyAPI = getCompany[0].text2
        }
      } else {
        MSG = res.data.ErrorMessage
      }

      if (Callback) {
        axios.defaults.baseURL = companyAPI

        console.log('CompamyCheck', {
          CompanyAPI: companyAPI,
          Message: MSG
        })

        Callback({
          CompanyAPI: companyAPI,
          Message: MSG
        })
      }
    });
  }
}
